import { render, staticRenderFns } from "./InvoiceBooks.vue?vue&type=template&id=55f27287&"
import script from "./InvoiceBooks.vue?vue&type=script&lang=js&"
export * from "./InvoiceBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports